<template>
  <el-table-column :label="label" :prop="prop" class-name="phone-number" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '電話番号'
    },
    prop: {
      type: String,
      default: 'phone_number'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.phone-number {
      width: 10em;
    }
  }
}
</style>
